import React, { memo, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Col, Row } from 'react-bootstrap';
import { setIsUserSubscribed, setLoginCallLocation, setLoginModal, setLoginTab, setPropertyToSaveFrom, setSubscribeEmailAlreadyExists } from '@/redux/login/loginSlice';
import { subscribeUser } from '@/api/favorites';
import { setCookie } from '@/utils/cookies';
import { setIsAddedToSaved, showSavedTooltip } from '@/redux/savedpreference/savedPreferenceSlice';
import { onSavePress, onUnsavePress } from '@/api/srpFilter';
import { updateSaveProperty } from '@/redux/PDP/pdpSlice';
import { getEventCategory, trackApiCall, trackButtonClick } from '@/utils/analytics';

const PDPSaveModal = ({showModal, setShowModal, isBidCenter, isHideArrow = false}) => {
  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);
  const userEmailId = useSelector((state) => state.user?.user?.userEmailId)
  const {isUserSubscribed} = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const [email, setEmail] = useState();
  const [emailError, setEmailError] = useState();

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
  }
  const onSave = async () => {
    const propertyId = pdpInitData?.propertyDetails?.propertyId;
    if (userEmailId || isUserSubscribed) {
      if (pdpInitData?.propertySpecialDetails?.onWatchList === "Y") {
        dispatch(updateSaveProperty("N"));

        trackButtonClick({
          eventName: "favourite_property_unsave_click",
          eventCategory: "NEW-PDP",
          eventSource: "pdp_save_modal",
          eventLabel: `Property Id: ${
            pdpInitData?.propertyDetails?.propertyId
          }|propertyStatus: ${
            pdpInitData?.propertyDetails?.commonAttributes?.status || "N/A"
          }`,
        });

        const response = await onUnsavePress({ propertyId });
        if (response === "success") {
          dispatch(setIsAddedToSaved());

          trackApiCall({
            eventName: "favourite_property_unsaved",
            eventCategory: "NEW-PDP",
            eventSource: "pdp_save_modal",
            eventLabel: `Property Id: ${propertyId}`,
          });
        } else {
          trackApiCall({
            eventName: "favourite_property_unsave_error",
            eventCategory: "Error",
            eventSource: `Error - ${
              response?.message || "Data Initialization Failed"
            }`,
            eventLabel: `Property Id: ${propertyId}`,
          });
        }
      } else {
        dispatch(updateSaveProperty("Y"));

        trackButtonClick({
          eventName: "favourite_property_save_click",
          eventCategory: "NEW-PDP",
          eventSource: "pdp_save_modal",
          eventLabel: `Property Id: ${
            pdpInitData?.propertyDetails?.propertyId
          }propertyStatus: ${
            pdpInitData?.propertyDetails?.commonAttributes?.status || "N/A"
          }`,
        });

        const response = await onSavePress({ propertyId });

        if (response === "success") {
          dispatch(showSavedTooltip(true));
          dispatch(setIsAddedToSaved());

          trackApiCall({
            eventName: "favourite_property_saved",
            eventCategory: "NEW-PDP",
            eventSource: "pdp_save_modal",
            eventLabel: `Property Id: ${propertyId}`,
          });
        } else {
          trackApiCall({
            eventName: "favourite_property_save_error",
            eventCategory: "Error",
            eventSource: `Error - ${
              response?.message || "Data Initialization Failed"
            }`,
            eventLabel: `Property Id: ${propertyId}`,
          });
        }
      }
    } else {
      setShowModal(true);
    }
  };

  const validateEmail =  async () =>{
    var isValidEmail = true;
    if (!email) {
        setEmailError("Please enter vaild email")
        isValidEmail = false;
    }
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
        isValidEmail = false
        setEmailError("Please enter vaild email")
    };
    if (isValidEmail) {
        setEmailError("")
    }
    if (isValidEmail) {
      trackButtonClick({
        eventName: "quick_registration_click",
        eventCategory: "NEW-PDP",
        eventSource: "on quick register",
        eventLabel: "referrer: QuickRegister"
      })

      const data = await subscribeUser(email);
      if (data?.data === "EMAIL_ALREADY_EXIST") {
        loginNavigation()
        dispatch(setSubscribeEmailAlreadyExists(true))
        setCookie("userEmail",email,30)
        setCookie("loggedInEmail",email,30)
        dispatch(setIsUserSubscribed(false))
      } else {
        setShowModal(false)
        setCookie("userEmail",email,30)
        setCookie("subscribedUser",true,30)
        setCookie("loggedInEmail",email,30)
        setCookie("subscribeEmail",window.btoa(email),30)
        dispatch(setIsUserSubscribed(true))
        dispatch(setSubscribeEmailAlreadyExists(false))
        dispatch(setPropertyToSaveFrom("PDP"));
        onSave();

        // Persist the analytics user id in a cookie ONLY (not Redux) so it never
        // leaks into API payloads that read state.user.user.realbidUserId.
        // Analytics picks it up via getUserContext()'s `gaUserId` fallback, so
        // user_uid is attached to all events during the registration window.
        if (data?.data?.realBidUserId) {
          setCookie("gaUserId", data.data.realBidUserId, 30);
        }

        trackApiCall({
          eventName: "register_completed",
          eventCategory: "NEW-PDP",
          eventSource: "on quick register completed",
          eventLabel: "referrer: QuickRegister",
          user_uid: data?.data?.realBidUserId || "",
        });

        trackButtonClick({
          eventName: "quick_register",
          eventCategory: getEventCategory(),
          eventSource: "referrer: QuickRegister",
          user_uid: data?.data?.realBidUserId || "",
        });
      }
    }
    return isValidEmail
  }

  const loginNavigation = () => {
    setShowModal(false);
    dispatch(setLoginModal(true));
    dispatch(setLoginTab("loginTab"));
    dispatch(setLoginCallLocation("Popup"));
    dispatch(setPropertyToSaveFrom("PDP"));
  };

  document.addEventListener("click", (event) => {
    if (showModal) {
      const pdpSaveModal = document.getElementById("pdpSaveModal");
      const pdpSaveBtn = document.getElementById(isBidCenter ? "pdpAddSave" : "pdpSaveBtn");
      if ((pdpSaveModal && !pdpSaveModal.contains(event.target))) {
        if (pdpSaveBtn && !pdpSaveBtn.contains(event.target)){
          setShowModal(false);
        }
      }
    }
  });

  return (
    <div>
      <div className="dropdown-menu saveDropdownPDP" id="pdpSaveModal">
        {!isHideArrow && <div className='pdp-arrow-up'></div>}
      <div className="d-flex justify-content-between p10 pl15 pr15 pb0">
        <div className="d-flex">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
            <path fill="#d83e3b" enableBackground="new" d="M20.7,6.2c-3-3.9-8.8-1.6-8.8,2.3C11.9,4.6,6,2.3,3,6.2c-3.1,4,0,11,8.8,15
            C20.8,17.2,23.8,10.2,20.7,6.2z"></path>
            <path className="icon-outer-layer" fill="none" stroke="#d83e3b" strokeWidth="2" strokeMiterlimit="10" d="M20.7,6.2c-3-3.9-8.8-1.6-8.8,2.3
            C11.9,4.6,6,2.3,3,6.2c-3.1,4,0,11,8.8,15C20.8,17.2,23.8,10.2,20.7,6.2z"></path>
          </svg>
          <div className="pdpSaveHead pt5 pl10">Save this listing</div>
        </div>
        <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
      </div>
      <div className="spss saveListing p30 pt0">
        <Row xs={12} md={12} className="d-flex align-items-start">
          <p className="save-popup-heading">Enter your e-mail to save this property to your favorites and to keep track of price and status changes.</p>
          <Col xs={8} md={8} className="d-flex align-items-start">
            <Row>
              <div className="d-flex p0">
                <input type="email"
                  className="form-control hubzu-text-box pdpInput"
                  id="pdpSaveEmail"
                  aria-label="email"
                  autoComplete="none"
                  onChange={handleChange}
                  onFocus={() => {
                    const label = document.getElementById("pdpPlaceholder");
                    label.style.display = 'none';
                  }}
                  onBlur={() => {
                    const label = document.getElementById("pdpPlaceholder");
                    label.style.display = 'block';
                  }}
                  required
                />
                {!email && <div
                  id="pdpPlaceholder"
                  className="pdpPlaceholder"
                  onClick={(e) => {
                    const textInput = document.getElementById("pdpSaveEmail");
                    textInput.focus()
                  }}
                >
                  Email Address <span className="pdpAsterisk">*</span>
                </div>}
              </div>
              {emailError?.length > 0 &&
                <span className="error-message pt20 pb0">
                  {emailError}
                </span>
              }
              <p className="haveAnyAccount pt10">
                Already have an account?{" "}
                <a className="saveLoginText" onClick={loginNavigation}>
                  Sign In
                </a>
              </p>
            </Row>
          </Col>
          <Col xs={4} md={4} className="smallFont d-flex align-items-start p0">
            <button
              className='pdpRegisterBtn ml20'
              onClick={() =>
              validateEmail()
              }>
              Register
            </button>
          </Col>
        </Row>
      </div>
    </div>
      <div className='saveDropdownPDP-backdrop' />
    </div>
  );
};
export default memo(PDPSaveModal);